module.exports = __webpack_public_path__ + "img/dhl.878187c6.png";